var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ff-context-menu"},[_c('ff-button',{ref:"",staticClass:"trigger",class:{
      'is-hidden': _vm.show,
    },attrs:{"data-ref":_vm.trigger,"text":_vm.text,"action":function (){return},"icon":_vm.iconRender,"pattern":2}}),_c('ff-menu',{staticClass:"menu",class:{'is-active': _vm.show},style:(_vm.style),attrs:{"items":_vm.items},on:{"action":_vm.bubbleAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }